export interface SalesDespatchItemProcessingReport {
  processProductKey: string;
  processProductDescription: string;
  processCost: string;
  processValue: string;
  currencySymbol: string;
}
